import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    f.fbq('init', '1214319980911777');
    f.fbq('track', 'PageView');
    // Utmify tracking script
    const utmScript = document.createElement('script');
    utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmScript.setAttribute('data-utmify-prevent-subids', '');
    utmScript.async = true;
    utmScript.defer = true;
    document.head.appendChild(utmScript);
  }, []);
  return <SalesPage data-id="element-0" />;
}